module.exports = __webpack_public_path__ + "img/swap-line-long.0f44110c.svg";